import { render, staticRenderFns } from "./RegistersPregnant.vue?vue&type=template&id=20281f0b&scoped=true&"
import script from "./RegistersPregnant.vue?vue&type=script&lang=js&"
export * from "./RegistersPregnant.vue?vue&type=script&lang=js&"
import style0 from "./RegistersPregnant.vue?vue&type=style&index=0&id=20281f0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20281f0b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VContainer,VImg,VRow,VSheet})
